import { Keybinding, ResolvedKeybinding, SimpleKeybinding } from '@vscode-alt/monaco-editor/esm/vs/base/common/keyCodes';
import { ScanCodeBinding } from '@vscode-alt/monaco-editor/esm/vs/base/common/scanCode';
import { IKeyboardEvent } from '@vscode-alt/monaco-editor/esm/vs/platform/keybinding/common/keybinding';
import { IKeyboardMapper } from '@workbench-stack/core';

export class CachedKeyboardMapper implements IKeyboardMapper {

    private _actual: IKeyboardMapper;
    private _cache: Map<string, ResolvedKeybinding[]>;

    constructor(actual: IKeyboardMapper) {
        this._actual = actual;
        this._cache = new Map<string, ResolvedKeybinding[]>();
    }

    public dumpDebugInfo(): string {
        return this._actual.dumpDebugInfo();
    }

    public resolveKeybinding(keybinding: Keybinding): ResolvedKeybinding[] {
        const hashCode = keybinding.getHashCode();
        const resolved = this._cache.get(hashCode);
        if (!resolved) {
            const r = this._actual.resolveKeybinding(keybinding);
            this._cache.set(hashCode, r);
            return r;
        }
        return resolved;
    }

    public resolveKeyboardEvent(keyboardEvent: IKeyboardEvent): ResolvedKeybinding {
        return this._actual.resolveKeyboardEvent(keyboardEvent);
    }

    public resolveUserBinding(parts: (SimpleKeybinding | ScanCodeBinding)[]): ResolvedKeybinding[] {
        return this._actual.resolveUserBinding(parts);
    }
}
